export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 9_09.3f6f7e05.jpg";